module.exports = __webpack_public_path__ + "img/product-chuti-qt-08.8838a7f6.png";